import { useEffect, useState } from 'react';
import { io, type Socket } from 'socket.io-client';
import { API_URL } from '../api/client';
import { useAuthStore } from '../store/auth';

export function useSocket(namespace: string): Socket | null {
  const token = useAuthStore((s) => s.token);
  const [socket, setSocket] = useState<Socket | null>(null);

  useEffect(() => {
    if (!token) return;
    const instance = io(`${API_URL}/${namespace}`, { auth: { token } });
    const onConnectError = (err: Error) => {
      console.error(`Сокет "${namespace}": ошибка подключения`, err.message);
    };
    const onDisconnect = (reason: string) => {
      console.warn(`Сокет "${namespace}": отключён (${reason})`);
    };
    instance.on('connect_error', onConnectError);
    instance.on('disconnect', onDisconnect);
    setSocket(instance);
    return () => {
      instance.off('connect_error', onConnectError);
      instance.off('disconnect', onDisconnect);
      instance.disconnect();
      setSocket(null);
    };
  }, [namespace, token]);

  return socket;
}
